import { announcementBannerSettingsV4Resource } from '@jira/admin-pages__system-announcement-banner-resources/src/useAnnouncementBannerSettingsV4Resource.tsx';
import { assetsUserPermissionResource } from '@atlassian/jira-router-resources-assets-user-permission/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { getConsentBannerUserPreferencesResource } from '@atlassian/jira-router-resources-cookie-consent/src/index.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import { themePreferenceResource } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import {
	assetsBannerSettingsResource,
	assetsNavigationSettingsResource,
} from '@atlassian/jira-router-resources-assets-admin-settings/src/index.tsx';

export function getCmdbResources() {
	return [...getNavigationResources(), ...getServicedeskPageContextResources(), workspaceResource];
}

export function getAssetsAppResources() {
	return [
		workspaceResource,
		themePreferenceResource,
		resourceWithCondition2(() => fg('aurum-997-license-kill-switch'), assetsUserPermissionResource),
		resourceWithCondition2(
			() => fg('assets-announcement-banner-settings'),
			assetsNavigationSettingsResource,
		),
		resourceWithCondition2(
			() => fg('assets-announcement-banner-settings'),
			assetsBannerSettingsResource,
		),
		rovoEntitlementResource,
		getConsentBannerUserPreferencesResource(),
		resourceWithCondition2(
			() => fg('show_announcement_banner_in_assets'),
			announcementBannerSettingsV4Resource,
		),
	];
}
